import React, { useEffect, useState } from 'react';
import {Dialog, DialogContent, DialogActions, CircularProgress} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import UrlasserDialog from '../../central/components/dialogs/UrlasserDialog';
import UserList from './subcomponents/UserList'
import {useQuery, useMutation} from 'react-apollo';
import {USER_LIST, PROJECT_LIST, CREATE_USER, EDIT_USER} from '../admin.gql';

export default function EditUsers (props) {
    const {open, onClose} = props;
    const [disableConfirm, setDisableConfirm] = useState(true);
    const {data, loading, error} = useQuery(USER_LIST, {fetchPolicy:'no-cache'});
    const {data:projects, loading:projectsLoading} = useQuery(PROJECT_LIST, {fetchPolicy:'no-cache'});
    const [createUser] = useMutation(CREATE_USER);
    const [editUser] = useMutation(EDIT_USER);
    const [openUrlasserDialog, setOpenUrlasserDialog] = useState(false); 
    const [user, setUser] = useState(null);
    
    const handleOpenUrlasserDialog = () => {
        setOpenUrlasserDialog(true);
    };
    const handleCloseUrlasserDialog = () => {
        setOpenUrlasserDialog(false);
    };

    const handleAfterVerify = () => {
        const {username, name, password, isAdmin, accessAuthorizations} = user;
        if (!user.id){
            createUser({
                variables:{
                    username: username,
                    name: name,
                    password: password,
                    isAdmin: isAdmin,
                    projects: accessAuthorizations
                }
            }).then( data => { 
                if (data) { 
                    setUser(null);
                    handleCloseUrlasserDialog();
                    onClose();
                }
            }).catch( err => console.log(err))
        }else{
            accessAuthorizations.forEach( el => delete el.__typename);
            editUser({
                variables:{
                    id: user.id,
                    username: username,
                    name: name,
                    isAdmin: isAdmin,
                    projects: accessAuthorizations
                }
            }).then( data => { 
                if (data) { 
                    setUser(null);
                    handleCloseUrlasserDialog();
                    onClose();
                }
            }).catch( err => console.log(err)) 
        } 
    };
    // console.log(user)
    useEffect(() => {
        if (user && !user.id){
            const {username, name, password} = user;
            if (username!=='' && name!=='' && password!=='') setDisableConfirm(false)
        }else if (user && user.id){
            setDisableConfirm(false)
        }
    },[user]);
    console.log(user);
    if (error) console.log('Error');

    return (
        <div>
            <UrlasserDialog
                onVerifyClick={handleAfterVerify}
                onClose={handleCloseUrlasserDialog}
                open={openUrlasserDialog}
            />
            <Dialog open={open} onClose={onClose}>
                <AppBar position="static" color="primary">
                    <Toolbar>
                        <div><Typography variant="h5">Benutzerverwaltung</Typography></div>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    {loading && projectsLoading && <CircularProgress/>}
                    {data && projects && <UserList data={data} projects={projects} state={{body: [user, setUser]}}/>}
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={onClose}>Abbrechen</Button>
                    <Button color="primary" variant="contained" disabled={disableConfirm} onClick={handleOpenUrlasserDialog}>
                        Bestätigen
                    </Button>
                </DialogActions>
            </Dialog>
        </div>    
    );
};